<template>
    <!-- MAIN -->
    <section class="section">
    <div class="columns" id="main">
        <side-menu class="column is-2" 
        :header="productsHeader" 
        :items="products" 
        :selectedItemId="productId"
        v-on:elementClick="toggleChanges"></side-menu>
        <!-- CONTENT -->
        <main class="container column is-8 main">
            <changes-content-filter v-on:searchClick="searchHandler" :createNewItem="createChange" :filterGroups="filterGroups" v-on:filtrate="filtrateChanges" v-on:expand="expandAllCards"
            :infoMsg="filterMsg" :saveClick="saveClick" ></changes-content-filter>

            <!-- search results header -->
            <nav v-if="searchingText.length > 0" class="level-left">
              <div class="level-item">   
                 <p class="subtitle is-4"> 
                   <span>Search results for: {{ searchingText}}</span>
                  </p>
              </div>
              <b-tooltip label="Clear search results" class="level-item">    
                  <button class="delete" v-on:click="clearSearch">Clear</button>
              </b-tooltip>
            </nav>
            <br>
            
            <div
            v-for="(item, index) in changes"
            :key="index">   
                <change-card :change="item" v-on:edit="editChange" v-on:delete="deleteChangeModal" v-on:search="searchHandler"
                :action1="'edit'" :action2="'delete'" :action3="'search'" :isExpandedCard="mustExpandCards"></change-card> 
                <br>
            </div>
            <pagination class="is-centered" :urlBuilder="urlBuilder" 
                        v-bind:currentPage="page.pageNumber"
                        v-bind:lastPage="page.totalPages"/>    

                          <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>        
        </main>
        
      
        <!--END CONTENT -->      
        <change-editor v-if="isEditorVisible" v-on:closeChangeEditor="closeChangeEditor" 
        :changeId="this.changeId" :productId="productId" :header="changeEditorHeader"/>
        <delete-confirmer v-if="isDeleteModalVisible" :text="deleteMsg" :header="deleteHeader" 
        v-on:close="closeChangeDeleteWindow" :id="this.productId" v-on:delete="deleteChange"/>
        <changes-saver :filterType="filterType" :productId="productId" v-if="isSaveDialogVisible" v-on:closeSaveChangesWindow="closeSaveChangesWindow" v-on:saveChanges="saveChanges"> </changes-saver>
    </div>    
    </section>
    <!-- END MAIN -->
</template>

<script>
// import AppHeader from "./components/AppHeader";
import SideMenu from "../SideMenu";
import AppBreadcrumb from "../AppBreadcrumb";
import ChangesContentFilter from "../ChangesContentFilter";
import ChangeCard from "../ChangeCard";
import ChangeEditor from "../ChangeEditor";
import DeleteConfirmer from "../DeleteConfirmer";
import Pagination from "vue-bulma-pagination/src/Pagination";
import ChangesSaver from "../ChangesSaver";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

//import this.HTTP from "../Http";
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export default {
  name: "changes-view",
  components: {
    SideMenu,
    AppBreadcrumb,
    ChangesContentFilter,
    ChangeCard,
    ChangeEditor,
    DeleteConfirmer,
    Pagination,
    Loading,
    ChangesSaver
  },
  data() {
    return {
      products: [],
      changes: [],
      productsHeader: "Products",
      isEditorVisible: false,
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this change?",
      deleteMsg: "This change will be losted forever!!!(",
      productId: -1,
      changeId: -1,
      changeEditorHeader: "",

      //change filter params
      filterGroups: ["All", "Public", "Private"],
      filterType: "All",

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false,

      isSaveDialogVisible: false,
      saveType: "All",
      language: "english",
      fileType: "txt",
      mustExpandCards: false
    };
  },
  computed: {
    filterMsg: function() {
      if (this.page.totalItems > 0)
        return "<strong>" + this.page.totalItems + "</strong> changes";
      else return "";
    }
  },
  methods: {
    getProducts() {
      return new Promise((resolve, reject) => {
        this.HTTP.get("products/" + 1 + "/" + 100)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getChanges() {
      this.loading = true;
      let query = "changes/product/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query +=
        this.productId +
        "/" +
        this.page.pageNumber +
        "/" +
        this.page.pageSize +
        "/" +
        this.filterType;
      if (
        this.searchingText !== null &&
        this.searchingText !== undefined &&
        this.searchingText.length > 0
      ) {
        query += "/" + this.searchingText;
      }
      this.HTTP.get(query.replaceAll("#", "%23"))
        .then(response => {
          this.changes = response.data.entities;
          this.page = response.data.page;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    toggleChanges(productId) {
      this.productId = productId;
      this.page.pageNumber = 1;
      this.searchingText = "";
    },

    createChange() {
      this.isEditorVisible = true;
      this.changeId = -1; //shouldn't edit
      this.changeEditorHeader = "Create new change";
    },
    editChange(id) {
      this.isEditorVisible = true;
      this.changeId = id;
      this.changeEditorHeader = "Edit change";
    },
    deleteChangeModal(id) {
      this.isDeleteModalVisible = true;
      this.changeId = id;
    },
    deleteChange() {
      this.HTTP.delete(`changes/` + this.changeId)
        .then(response => {
          this.closeChangeDeleteWindow();
        })
        .catch(e => {
          console.log(e);
        });
    },
    closeChangeEditor() {
      this.isEditorVisible = false;
      this.getChanges(); //should be optimized!
    },
    closeChangeDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getChanges(); //should be optimized!
    },

    filtrateChanges(filterType) {
      this.filterType = filterType;
    },

    //pagination

    urlBuilder(page) {
      return { query: { ...this.$route.query, page } }; // Changing page in location query
    },

    searchHandler(searchingText) {
      this.searchingText = searchingText;
    },

    clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },
    pushUrl() {
      this.$router.push({
        path: "Changes",
        query: {
          productId: this.productId,
          page: this.page.pageNumber,
          search: this.searchingText,
          filterType: this.filterType
        }
      });
    },
    saveClick() {
      this.isSaveDialogVisible = true;
    },
    closeSaveChangesWindow() {
      this.isSaveDialogVisible = false;
    },
    saveChanges(saveType, language, fileType, groupingType, tagsList) {
      console.log(saveType, language);
      this.saveType = saveType;
      this.fileType = fileType;
      this.language = fileType == "json" ? "" : language;
      this.isSaveDialogVisible = false;

      this.$router.push({
        path: "ChangesSaving",
        query: {
          productId: this.productId,
          search: this.searchingText,
          filterType: this.filterType,
          saveType: this.saveType,
          language: this.language,
          fileType: this.fileType,
          grouping: groupingType,
          tags: tagsList
        }
      });
    },
    expandAllCards(mustExpand) {
      this.mustExpandCards = mustExpand;
    }
  },
  created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    console.log("http here!!!");
    console.log(this.userName);
    this.loading = true;
    this.HTTP.load(); //.then(() => {
    this.getProducts().then(response => {
      this.products = response.data.entities;
      if (
        response.data.entities.length > 0 &&
        (this.$route.query.productId == null || this.$route.query.productId < 0)
      )
        this.productId = !isNaN(this.selectedProductId)
          ? this.selectedProductId
          : response.data.entities[0].id;
      else this.productId = parseInt(this.$route.query.productId);
      //this.pushUrl();
      this.getChanges();
      //})
      // .catch(e => {
      //   console.log(e);
      // });
    });
  },
  watch: {
    $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.productId = parseInt(to.query.productId);
        this.searchingText = to.query.search;
        this.filterType = to.query.filterType;
      }
      // this.HTTP.setHeader().then(() => {})
      this.getChanges();
    },
    productId: function(val) {
      if (!isNaN(val)) this.selectedProductId = val;
      this.pushUrl();
    },
    searchingText: function(val) {
      this.pushUrl();
    },
    filterType: function(val) {
      this.pushUrl();
    },
    page: function(val) {
      this.pushUrl();
    }
  }
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

* {
  box-sizing: border-box;
}

body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

#main {
  display: flex;
  flex: 1;
}

#main > aside {
  flex: 0 0 10vw;
  /* background: beige; */
}

/* #main>nav {
    order: -1;
} */

.footer {
  /* background: yellowgreen; */
  height: 10vh;
}

/* footer, */
/* .article,
.nav,
.aside {
  padding: 1em;
} */

nav.navbar {
  padding: 0em;
}

.card {
  /* margin: 1em; */
}
</style>



// WEBPACK FOOTER //
// src/components/views/Changes.Vue